module.exports = __webpack_public_path__ + "media/svg-new/cyborg 1-b417c8d5.svg";